<template>
  <Page class="detailView">
    <div>
      <a-form-model
        ref="kuaiqianform"
        class="form"
        :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
        :model="kuaiqianform"
        layout="inline"
        :colon="false"
      >
        <div class="pageContent-title pb-4">主体信息</div>
        <div class="detailView-with-actions">
          <a-form-model-item label="供应商名称">
            <a-input
              v-model="kuaiqianform.companyName"
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="公司名称">
            <a-radio-group
              v-model="kuaiqianform.supplierSubjectType"
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
            >
              <a-radio value="1">有限责任公司</a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item
            label="营业执照"
            prop="businessLicensePictureUrl"
            :rules="[{ required: true, message: '营业执照不能为空', trigger: 'blur' }]"
          >
            <div style="display: flex">
              <PictureCardUpload
                v-model="kuaiqianform.businessLicensePictureUrl"
                tips="营业执照"
                uploadType="supplierMaterial"
                preview
                :maxFileSize="5"
                :itemWidth="200"
                :itemHeight="150"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
              <a-button
                v-if="!kuaiqianform.kuaiqianAuditStatus || kuaiqianform.kuaiqianAuditStatus == 'REJECTED'"
                style="margin-left: 20px; margin-top: 116px"
                :loading="businessLoading"
                @click="ocrIdentify(kuaiqianform.businessLicensePictureUrl, 'business')"
              >
                ocr识别营业执照
              </a-button>
            </div>
          </a-form-model-item>
          <div style="background-color: #f9f9f9; padding: 20px 30px; margin: 30px 0 30px 180px">
            <a-row :gutter="30">
              <a-col class="my-label-col" :span="8">
                <a-form-model-item
                  label="统一社会信用代码"
                  prop="businessRegno"
                  :rules="[{ required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }]"
                >
                  <a-input
                    v-model="kuaiqianform.businessRegno"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col class="my-label-col" :span="8">
                <a-form-model-item
                  label="商户名称"
                  prop="merchantName"
                  :rules="[{ required: true, message: '商户名称不能为空', trigger: 'blur' }]"
                >
                  <a-input
                    v-model="kuaiqianform.merchantName"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <div class="my-label-col">
                <a-form-model-item
                  label="经营省市区"
                  prop="businessLicenseRegion"
                  :rules="[{ required: true, message: '经营省市区不能为空', trigger: 'blur' }]"
                  width="200px"
                >
                  <BDistpicker
                    type="zh"
                    :list="options"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                    :value-arr="[
                      kuaiqianform.businessLicenseProvince,
                      kuaiqianform.businessLicenseCity,
                      kuaiqianform.businessLicenseRegion,
                    ]"
                    @provincesValueChang="provincesValueChang($event, 'businessLicense')"
                  ></BDistpicker>
                </a-form-model-item>
                <!-- <a-form-model-item
                  label="经营者/法人姓名"
                  prop="legalName"
                  :rules="[{ required: true, message: '姓名不能为空', trigger: 'blur' }]"
                >
                  <a-input
                    v-model="kuaiqianform.legalName"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  ></a-input>
                </a-form-model-item> -->
              </div>
            </a-row>
            <a-row :gutter="30">
              <a-col class="my-label-col" :span="8">
                <a-form-model-item
                  label="经营地址"
                  prop="businessLicenseAddress"
                  :rules="[{ required: true, message: '经营地址不能为空', trigger: 'blur' }]"
                >
                  <a-input
                    v-model="kuaiqianform.businessLicenseAddress"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col class="my-label-col" :span="24">
                <a-form-model-item
                  label="经营范围"
                  prop="constraintBusiness"
                  :rules="[
                    { required: true, message: '经营范围不能为空', trigger: 'blur' },
                    { max: 500, message: '经营范围不能超过500个字符', trigger: 'blur' },
                  ]"
                >
                  <a-input
                    type="textarea"
                    rows="8"
                    placeholder="请输入经营范围"
                    v-model="kuaiqianform.constraintBusiness"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <div class="my-label-col">
              <a-form-model-item
                label="经营期限"
                prop="businessLicenseCancelDate"
                :rules="[{ required: true, message: '经营期限不能为空', trigger: 'blur' }]"
              >
                <div style="display: flex; line-height: 30px">
                  <!-- <a-input v-model="kuaiqianform.businessLicenseHandleDate"></a-input> -->
                  <a-date-picker
                    v-model="kuaiqianform.businessLicenseHandleDate"
                    @change="onDateChange($event, 'businessLicenseHandleDate')"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  />
                  <div style="padding: 0 10px">至</div>
                  <a-date-picker
                    v-model="kuaiqianform.businessLicenseCancelDate"
                    @change="onDateChange($event, 'businessLicenseCancelDate')"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  />
                  <a-checkbox
                    style="margin-left: 10px"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                    v-model="kuaiqianform.businessLicenseCancelDateChecked"
                    :checked="kuaiqianform.businessLicenseCancelDateChecked"
                    @change="kuaiqianform.businessLicenseCancelDate = '9999-12-31'"
                  >
                    长期有效
                  </a-checkbox>
                </div>
              </a-form-model-item>
            </div>
          </div>

          <a-form-model-item
            label="邮箱"
            prop="kuaiqianAccount"
            :rules="[{ required: true, message: '邮箱不能为空', trigger: 'blur' }]"
          >
            <a-input
              v-model="kuaiqianform.kuaiqianAccount"
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="企业LOGO"
            prop="logo"
            :rules="[{ required: true, message: '企业LOGO不能为空', trigger: 'blur' }]"
            style="height: 170px; margin-bottom: 0"
          >
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.logo"
                preview
                fileType="png,jpg,jpeg"
                :itemWidth="200"
                :itemHeight="150"
                :maxFileSize="5"
                tips="点击上传"
              ></PictureCardUpload>
            </div>
          </a-form-model-item>
          <a-form-model-item
            label="旅行社许可证编号"
            prop="merchantLicenseNumber"
            :rules="[
              { required: true, message: '旅行社许可证编号不能为空', trigger: 'blur' },
              {
                pattern: /^L-[A-Z]{2}-([A-Z]{2}\d{5}|\d{5})(-\d+)?$/,
                message: '旅行社许可证编号格式不正确',
                trigger: 'blur',
              },
            ]"
          >
            <a-input v-model="kuaiqianform.merchantLicenseNumber"></a-input>
          </a-form-model-item>
        </div>
        <div class="pageContent-title pb-4">法人信息</div>
        <div class="detailView-with-actions">
          <a-form-model-item
            label="身份证人像面照片"
            prop="legalIdCardPersonPictureUrl"
            :rules="[{ required: true, message: '身份证人像照片不能为空', trigger: 'blur' }]"
          >
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.legalIdCardPersonPictureUrl"
                preview
                :itemWidth="200"
                :itemHeight="150"
                :maxFileSize="5"
                tips="点击上传身份证人像面照片"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
              <a-button
                v-if="!kuaiqianform.kuaiqianAuditStatus || kuaiqianform.kuaiqianAuditStatus == 'REJECTED'"
                style="margin-left: 20px; margin-top: 116px"
                :loading="idCardLoading"
                @click="ocrIdentify(kuaiqianform.legalIdCardPersonPictureUrl, 'idCard')"
              >
                ocr识别身份证
              </a-button>
            </div>
          </a-form-model-item>

          <div style="background-color: #f9f9f9; padding: 20px 30px; margin: 30px 0 30px 180px">
            <div class="my-label-col">
              <a-form-model-item
                label="姓名"
                prop="legalIdCardName"
                :rules="[{ required: true, message: '姓名不能为空', trigger: 'blur' }]"
              >
                <a-input
                  v-model="kuaiqianform.legalIdCardName"
                  :disabled="
                    kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                  "
                  placeholder="请输入姓名"
                  style="width: 200px"
                ></a-input>
              </a-form-model-item>
            </div>
            <div class="my-label-col">
              <a-form-model-item
                label="身份证号"
                prop="legalIdCardNumber"
                :rules="[{ required: true, message: '身份证号不能为空', trigger: 'blur' }]"
              >
                <a-input
                  v-model="kuaiqianform.legalIdCardNumber"
                  placeholder="请输入身份证号"
                  :disabled="
                    kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                  "
                  style="width: 200px"
                ></a-input>
              </a-form-model-item>
            </div>
          </div>
          <a-form-model-item
            label="身份证国徽面照片"
            prop="legalIdCardNationalPictureUrl"
            :rules="[{ required: true, message: '身份证国徽面照片不能为空', trigger: 'blur' }]"
          >
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.legalIdCardNationalPictureUrl"
                preview
                :itemWidth="200"
                :itemHeight="150"
                :maxFileSize="5"
                tips="点击上传身份证国徽面照片"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
              <a-button
                v-if="!kuaiqianform.kuaiqianAuditStatus || kuaiqianform.kuaiqianAuditStatus == 'REJECTED'"
                style="margin-left: 20px; margin-top: 116px"
                :loading="idCardBLoading"
                @click="ocrIdentify(kuaiqianform.legalIdCardNationalPictureUrl, 'idCardB')"
              >
                ocr识别身份证国徽面
              </a-button>
            </div>
          </a-form-model-item>
          <div style="background-color: #f9f9f9; padding: 20px 30px; margin: 30px 0 30px 180px">
            <div class="my-label-col">
              <a-form-model-item
                label="有效期限"
                prop="legalIdCardExpireDate"
                :rules="[{ required: true, message: '有效期限不能为空', trigger: 'blur' }]"
              >
                <div style="display: flex; line-height: 30px">
                  <!-- <a-input v-model="kuaiqianform.businessLicenseHandleDate"></a-input> -->
                  <a-date-picker
                    v-model="kuaiqianform.legalIdCardBeginDate"
                    @change="onDateChange($event, 'legalIdCardBeginDate')"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  />
                  <div style="padding: 0 10px">至</div>
                  <a-date-picker
                    v-model="kuaiqianform.legalIdCardExpireDate"
                    @change="onDateChange($event, 'legalIdCardExpireDate')"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                  />
                  <a-checkbox
                    style="margin-left: 10px"
                    :disabled="
                      kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'
                    "
                    v-model="kuaiqianform.legalIdCardExpireDateChecked"
                    :checked="kuaiqianform.legalIdCardExpireDateChecked"
                    @change="kuaiqianform.legalIdCardExpireDate = '9999-12-31'"
                  >
                    长期有效
                  </a-checkbox>
                </div>
              </a-form-model-item>
            </div>
          </div>
          <a-form-model-item
            label="经营法人移动电话"
            prop="legalTelephone"
            :rules="[{ required: true, message: '经营法人移动电话不能为空', trigger: 'blur' }]"
          >
            <a-input
              v-model="kuaiqianform.legalTelephone"
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              placeholder="请输入移动电话"
            />
          </a-form-model-item>
        </div>
        <div class="pageContent-title pb-4">结算账户</div>
        <div class="detailView-with-actions">
          <a-form-model-item label="账户类型">
            <a-input disabled value="对公账户"></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="开户名称(与营业执照相同)"
            prop="accountName"
            :rules="[{ required: true, message: '开户名称不能为空', trigger: 'blur' }]"
          >
            <a-input
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              v-model="kuaiqianform.accountName"
            ></a-input>
            <!-- autocomplete="off" -->
          </a-form-model-item>
          <a-form-model-item
            label="开户银行"
            prop="accountBankName"
            :rules="[{ required: true, message: '开户银行不能为空', trigger: 'blur' }]"
          >
            <a-input
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              v-model="kuaiqianform.accountBankName"
            ></a-input>
            <!-- autocomplete="off" -->
          </a-form-model-item>
          <a-form-model-item
            label="开户支行省市区"
            prop="accountBranchRegion"
            :rules="[{ required: true, message: '开户支行省市区不能为空', trigger: 'blur' }]"
          >
            <BDistpicker
              type="zh"
              :list="options"
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              :value-arr="[
                kuaiqianform.accountBranchProvince,
                kuaiqianform.accountBranchCity,
                kuaiqianform.accountBranchRegion,
              ]"
              @provincesValueChang="provincesValueChang($event, 'accountBranch')"
            ></BDistpicker>
          </a-form-model-item>
          <a-form-model-item
            label="开户支行全称"
            prop="accountBranchName"
            :rules="[{ required: true, message: '开户支行全称不能为空', trigger: 'blur' }]"
          >
            <a-input
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              v-model="kuaiqianform.accountBranchName"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="银行账号"
            prop="accountNumber"
            :rules="[{ required: true, message: '银行账号不能为空', trigger: 'blur' }]"
          >
            <a-input
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              v-model="kuaiqianform.accountNumber"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="开户凭证代码"
            prop="accOpenCode"
            :rules="[{ required: true, message: '开户凭证代码不能为空', trigger: 'blur' }]"
          >
            <a-input
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              v-model="kuaiqianform.accOpenCode"
            ></a-input>
          </a-form-model-item>

          <a-form-model-item
            label="开户凭证"
            prop="accOpenPictureUrl"
            :rules="[{ required: true, message: '开户凭证不能为空', trigger: 'blur' }]"
            style="height: 170px; margin-bottom: 0"
          >
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.accOpenPictureUrl"
                preview
                fileType="png,jpg,jpeg"
                :itemWidth="200"
                :itemHeight="150"
                :maxFileSize="5"
                tips="点击上传开户凭证"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
            </div>
          </a-form-model-item>
          <a-form-model-item label="经营许可证" style="height: 170px; margin-bottom: 0">
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.industryBusinessLicensePictureUrl"
                preview
                :itemWidth="200"
                :itemHeight="150"
                :maxFileSize="5"
                tips="点击上传经营许可证"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
            </div>
          </a-form-model-item>
        </div>
        <div class="pageContent-title pb-4">经营与行业信息</div>
        <div class="detailView-with-actions">
          <a-form-model-item
            label="经营场所/门店名称"
            prop="storeName"
            :rules="[{ required: true, message: '经营场所/门店名称不能为空', trigger: 'blur' }]"
          >
            <a-input
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              v-model="kuaiqianform.storeName"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="线下场所省市区"
            prop="storeRegion"
            :rules="[{ required: true, message: '线下场所省市区', trigger: 'blur' }]"
          >
            <BDistpicker
              type="zh"
              :list="options"
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              :value-arr="[kuaiqianform.storeProvince, kuaiqianform.storeCity, kuaiqianform.storeRegion]"
              @provincesValueChang="provincesValueChang($event, 'store')"
            ></BDistpicker>
          </a-form-model-item>
          <a-form-model-item
            label="经营场所/门店详细信息"
            prop="storeAddress"
            :rules="[{ required: true, message: '经营场所/门店详细信息不能为空', trigger: 'blur' }]"
          >
            <a-input
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              v-model="kuaiqianform.storeAddress"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="经营场所/门店门头照片"
            prop="storeHeadPictureUrl"
            :rules="[{ required: true, message: '经营场所/门店门头照片不能为空', trigger: 'blur' }]"
            style="margin-top: 20px; height: 170px; margin-bottom: 0"
          >
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.storeHeadPictureUrl"
                preview
                :itemWidth="200"
                :itemHeight="150"
                :maxFileSize="5"
                tips="点击上传经营场所/门店门头照片"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
            </div>
          </a-form-model-item>
          <a-form-model-item
            label="经营场所/门店内景照片"
            prop="storeInDoorPictureUrl"
            :rules="[{ required: true, message: '经营场所/门店内景照片不能为空', trigger: 'blur' }]"
            style="margin-top: 20px; height: 170px; margin-bottom: 0"
          >
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.storeInDoorPictureUrl"
                preview
                :itemWidth="200"
                :itemHeight="150"
                :maxFileSize="5"
                tips="点击上传经营场所/门店内景照片"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
            </div>
          </a-form-model-item>
          <a-form-model-item
            label="开户意愿确认函"
            prop="openConfirmPictureUrl"
            :rules="[{ required: true, message: '开户意愿确认函不能为空', trigger: 'blur' }]"
            style="margin-top: 20px; height: 170px; margin-bottom: 0"
          >
            <div class="flex">
              <PictureCardUpload
                v-model="kuaiqianform.openConfirmPictureUrl"
                preview
                :itemWidth="200"
                :itemHeight="150"
                :max-file-size="5"
                tips="点击上传确认函"
                :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
              ></PictureCardUpload>
            </div>
          </a-form-model-item>
        </div>
        <div class="pageContent-title pb-4">合作信息</div>
        <div class="detailView-with-actions">
          <a-form-model-item
            label="联系人姓名"
            prop="contactName"
            :rules="[{ required: true, message: '联系人姓名不能为空', trigger: 'blur' }]"
          >
            <a-input v-model="kuaiqianform.contactName"></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="联系方式"
            prop="contactPhone"
            :rules="[{ required: true, message: '联系方式不能为空', trigger: 'blur' }]"
          >
            <a-input v-model="kuaiqianform.contactPhone"></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="业务类型"
            prop="businessTypeList"
            :rules="[{ required: true, message: '业务类型不能为空', trigger: 'blur' }]"
          >
            <a-select
              v-model="kuaiqianform.businessTypeList"
              mode="multiple"
              :disabled="kuaiqianform.kuaiqianAuditStatus !== null && kuaiqianform.kuaiqianAuditStatus !== 'REJECTED'"
            >
              <a-select-option v-for="item in businessTypeList" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            label="服务费率"
            prop="serviceRate"
            :rules="[{ required: true, message: '服务费不能为空', trigger: 'blur' }]"
          >
            <a-input v-model="kuaiqianform.serviceRate" addon-after="千分之"></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="合同AppId"
            prop="contractAppId"
            :rules="[{ required: true, message: '合同AppId不能为空', trigger: 'blur' }]"
          >
            <a-input v-model="kuaiqianform.contractAppId"></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="合同signKey"
            prop="contractSignKey"
            :rules="[{ required: true, message: '合同signKey不能为空', trigger: 'blur' }]"
          >
            <a-input v-model="kuaiqianform.contractSignKey"></a-input>
          </a-form-model-item>
        </div>
        <div v-if="kuaiqianform.kuaiqianAuditStatus === 'REJECTED'">
          <a-form-model-item style="margin-top: 20px; margin-bottom: 0">
            <label slot="label" style="color: red">审核失败</label>
            <div class="flex">
              失败原因:
              {{ kuaiqianform.kuaiqianAuditRejectedComments }}
            </div>
          </a-form-model-item>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; width: 100%">
          <a-button v-if="!kuaiqianform.kuaiqianAuditStatus" class="app-btn" type="primary" @click="submitKuaiQian">
            提交
          </a-button>
          <a-button
            v-else-if="kuaiqianform.kuaiqianAuditStatus === 'REJECTED'"
            class="app-btn"
            type="primary"
            @click="submitKuaiQian"
          >
            重新提交审核
          </a-button>
          <a-button
            v-else-if="kuaiqianform.kuaiqianAuditStatus == 'FINISHED'"
            class="app-btn"
            type="primary"
            @click="submitKuaiQian"
          >
            保存
          </a-button>
          <a-button v-else disabled class="app-btn" type="primary" @click="submitKuaiQian">
            {{ kuaiqianform.kuaiqianAuditStatus | getKuaiqianStatus }}
          </a-button>

          <a-button class="app-btn" type="primary" style="margin-left: 30px" @click="back">返回</a-button>
        </div>
      </a-form-model>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import { toolMixin } from '@/utils/mixin'
import moment from 'moment'
import BDistpicker from '@/components/Distpicker/Distpicker-b'
import { FormModel } from 'ant-design-vue'
export default {
  components: {
    Page,
    PictureCardUpload,
    BDistpicker,
    AFormModel: FormModel,
  },

  mixins: [toolMixin],
  filters: {
    getBusinessName(type, list) {
      return list.find(v => v.value === type).label
    },
    getKuaiqianStatus(status) {
      return status === 'UPLOADING'
        ? '提交中'
        : status === 'AUDITING'
        ? '审核中'
        : status === 'REJECTED'
        ? '审批拒绝'
        : status === 'TO_BE_SIGNED'
        ? '合同待签约'
        : status === 'FINISHED'
        ? '已完成'
        : '未知'
    },
  },
  data() {
    return {
      kuaiqianform: {
        businessTypeList: [],
        serviceRate: null,
        merchantLicenseNumber: null,
        kuaiqianAuditStatus: null,
        supplierSubjectType: '1',
        businessLicensePictureUrl: null,
        businessRegno: null,
        merchantName: null,
        contactName: null,
        contactPhone: null,
        legalName: null,
        constraintBusiness: null,
        businessLicenseProvince: null,
        businessLicenseCity: null,
        businessLicenseRegion: null,
        businessLicenseAreaCode: null,
        businessLicenseAddress: null,
        kuaiqianAccount: null,
        businessLicenseHandleDate: null,
        businessLicenseCancelDate: null,
        legalIdCardPersonPictureUrl: null,
        legalIdCardNationalPictureUrl: null,
        legalIdCardName: null,
        legalIdCardNumber: null,
        legalIdCardBeginDate: null,
        legalIdCardExpireDate: null,
        legalTelephone: null,
        accountName: null,
        accountBankName: null,
        accountBranchName: null,
        accountBranchProvince: null,
        accountBranchAreaCode: null,
        accountBranchCity: null,
        accountBranchRegion: null,
        accountBank: null,
        accountNumber: null,
        accOpenPictureUrl: null,
        accOpenCode: null,
        storeName: null,
        storeProvince: null,
        storeCity: null,
        storeRegion: null,
        storeAreaCode: null,
        storeAddress: null,
        storeHeadPictureUrl: null,
        storeInDoorPictureUrl: null,
        openConfirmPictureUrl: null,
      },
      businessLoading: false,
      idCardLoading: false,
      idCardBLoading: false,
      loading: false,
      options: [],
      businessTypeList: [
        {
          value: 1,
          label: '签证',
        },
        {
          value: 10,
          label: '跟团游',
        },
        {
          value: 20,
          label: '定制',
        },
      ],
    }
  },
  async mounted() {
    const id = this.$route.query.supplierId
    if (id) {
      await this.loadById(id)
    }
    this.getRegionList()
  },
  methods: {
    getRegionList() {
      this.$axios
        .get('/auxiliary/admin/region', {
          params: {
            page: 1,
            limit: 10000,
            level: 1,
          },
        })
        .then(res => {
          if (!res.success) return
          this.options = res.data
        })
    },
    provincesValueChang(value, type) {
      this.kuaiqianform[type + 'Province'] = value[0].label
      this.kuaiqianform[type + 'City'] = value[1].label
      this.kuaiqianform[type + 'Region'] = value[2].label
      if (value[2]) {
        this.kuaiqianform[type + 'AreaCode'] = value[2].value
      }
      console.log(this.kuaiqianform)
    },
    onDateChange(e, type) {
      this.kuaiqianform[type] = moment(e).format('YYYY-MM-DD')
    },
    submitKuaiQian() {
      this.$refs.kuaiqianform.validate((valid, errors) => {
        if (valid) {
          this.kuaiqianform.legalName = this.kuaiqianform.legalIdCardName
          this.$axios
            .post('/user/admin/supplier/detail', {
              ...this.kuaiqianform,
            })
            .then(res => {
              if (res.success) {
                this.loadById(res.data)
              }
            })
        } else {
          // 验证失败时滚动到第一个错误位置
          this.$nextTick(() => {
            // 方法1：通过 ant-form-explain 类查找
            const firstErrorExplain = document.querySelector('.ant-form-explain')

            if (firstErrorExplain) {
              // 向上查找最近的表单控件
              const formItem = firstErrorExplain.closest('.ant-form-item')

              if (formItem) {
                formItem.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                })
              }
            }
          })
        }
      })
    },
    async getRegionInfo(regionName, type) {
      const address = await this.$axios.get('/auxiliary/admin/region', {
        params: {
          regionName,
        },
      })
      if (address.success && address.data && address.data.length > 0) {
        this.kuaiqianform[type] = address.data[0].regionId
      }
    },
    ocrIdentify(url, type) {
      const theName = type === 'business' ? '营业执照' : type === 'idCard' ? '身份证人像面' : '身份证国徽面'
      if (!url) {
        return this.$message.error(`请上传${theName}`)
      }
      if (type === 'business') {
        this.businessLoading = true
        this.$axios
          .post('/auxiliary/admin/ocr/businessLicense', {
            url,
          })
          .then(res => {
            this.businessLoading = false
            if (res.success) {
              this.kuaiqianform.businessRegno = res.data.creditCode || res.data.certSN
              this.kuaiqianform.merchantName = res.data.companyName
              this.kuaiqianform.businessLicenseAddress = res.data.addressDetail
              this.kuaiqianform.businessLicenseHandleDate = res.data.establishDate
              this.kuaiqianform.constraintBusiness = res.data.business
              this.kuaiqianform.businessLicenseCancelDate = res.data.vaildPeriod
              this.kuaiqianform.businessLicenseProvince = res.data.province
              this.kuaiqianform.businessLicenseCity = res.data.city
              this.kuaiqianform.businessLicenseRegion = res.data.district
              if (this.kuaiqianform.businessLicenseRegion) {
                this.getRegionInfo(this.kuaiqianform.businessLicenseRegion, 'businessLicenseAreaCode')
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.businessLoading = false
          })
      } else if (type === 'idCard') {
        this.idCardLoading = true
        this.$axios
          .post('/auxiliary/admin/ocr/idcard/person', {
            url,
          })
          .then(res => {
            if (res.success) {
              this.idCardLoading = false
              this.kuaiqianform.legalIdCardName = res.data.name
              this.kuaiqianform.legalIdCardNumber = res.data.number
            }
            this.idCardLoading = false
          })
          .catch(error => {
            console.log(error)
            this.idCardLoading = false
          })
      } else if (type === 'idCardB') {
        this.idCardBLoading = true
        this.$axios
          .post('/auxiliary/admin/ocr/idcard/national', {
            url,
          })
          .then(res => {
            if (res.success) {
              this.idCardBLoading = false
              this.kuaiqianform.legalIdCardBeginDate = res.data.startDate
              if (res.data.permanent) {
                this.kuaiqianform.legalIdCardExpireDateChecked = true
                this.kuaiqianform.legalIdCardExpireDate = '9999-12-31'
              } else {
                this.kuaiqianform.legalIdCardExpireDate = res.data.endDate
              }
            }
            this.idCardBLoading = false
          })
          .catch(error => {
            console.log(error)
            this.idCardBLoading = false
          })
      }
    },
    back() {
      this.$router.go(-1)
    },
    async loadById(supplierId) {
      const res = await this.$axios.get(`/user/admin/supplier/detail/${supplierId}`)
      this.kuaiqianform = res.data
      if (this.kuaiqianform.accountBranchRegion) {
        this.getRegionInfo(this.kuaiqianform.accountBranchRegion, 'accountBranchAreaCode')
      }
      if (this.kuaiqianform.storeRegion) {
        this.getRegionInfo(this.kuaiqianform.storeRegion, 'storeAreaCode')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.detailView-with-actions {
  ::v-deep .ant-form-item-label {
    min-width: 180px;
  }
  ::v-deep .ant-form-item-control-wrapper {
    width: 616px;
  }
}
.my-label-col {
  ::v-deep .ant-form-item-label {
    min-width: 140px;
  }
  ::v-deep .ant-form-item-control-wrapper {
    width: 100%;
  }
}
.tag-c {
  margin: 0 10px 10px 0;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tips {
  position: absolute;
  top: 10px;
  left: -40px;
  color: #ffb831;
}
.info-tag {
  position: relative;
  white-space: nowrap;
  &.deletable:hover {
    background: @primary-color;
    border: 0;
    color: #fff;
    box-shadow: 0px 5px 10px 0px rgba(255, 106, 101, 0.5);
    display: block;
    .delete-btn {
      display: block;
    }
  }
  .delete-btn {
    display: none;
    position: absolute;
    background: @primary-color;
    border-radius: 50%;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    cursor: pointer;
    font-size: 12px;
  }
}
</style>
